import React, { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getOptimizedImageUrl, getImageSrcSet } from "../../utils/imageUrl";
import "./StoriesBar.css";

function StoriesBar({ stories, onStoryClick, viewedStories = new Set() }) {
  const { t } = useTranslation();
  const scrollRef = useRef(null);

  // Auto-scroll to show gradient ring stories (unviewed) first
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 0;
    }
  }, []);

  if (!stories || stories.length === 0) {
    return null;
  }

  return (
    <nav className="stories-bar" ref={scrollRef} aria-label={t("nav.stories")}>
      <div className="stories-container">
        {stories.map((story, index) => {
          const isViewed = viewedStories.has(story.id);
          const isSpecial = story.id === "daily-specials" || story.id === "featured";

          return (
            <button
              key={story.id}
              className={`story-circle ${isViewed ? "viewed" : ""} ${isSpecial ? "special" : ""}`}
              onClick={() => onStoryClick(story.id, index)}
              aria-label={t('stories.view', { name: story.name })}
            >
              <div className="story-ring">
                <div className="story-image-wrapper">
                  {story.imageUrl ? (
                    <img
                      src={getOptimizedImageUrl(story.imageUrl, { width: 76 })}
                      srcSet={getImageSrcSet(story.imageUrl, 76)}
                      sizes="(max-width: 768px) 60px, 76px"
                      alt={story.name}
                      width={76}
                      height={76}
                      loading="lazy"
                      decoding="async"
                      className="story-image"
                    />
                  ) : (
                    <div className="story-placeholder">
                      <span className="material-icons" aria-hidden="true">
                        {isSpecial ? "auto_awesome" : "restaurant_menu"}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <span className="story-name">{story.name}</span>
              {story.itemCount > 0 && (
                <span className="story-count">{story.itemCount}</span>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default StoriesBar;
